import "./contact.scss"

export default function Contact() {
  return (
    <div className="contact" id="contact">
      <div className="container1">
      <div className="test" >
        <a href="https://www.canva.com/design/DAE4gakUnqs/qGzeKT0eyBy-eUaHjYZ4zQ/view?utm_content=DAE4gakUnqs&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink">Download My Resume</a> 
      
      </div>
      
      </div>
    </div>
  )
}
